const Fail = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br min-h-[70vh]">
      <div className="bg-white p-12 rounded-2xl shadow-2xl text-center max-w-md">
        <div className="mb-6">
          <svg
            className="w-16 h-16 mx-auto text-red-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          გადახდა ვერ განხორციელდა
        </h1>
      </div>
    </div>
  );
};

export default Fail;
